















































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import Endpoint from '../../utils/endpoint';

import Menu from '@/types/profile/menu';
import Permission from '@/types/profile/permission';
import Area from '../../types/profile/area';

@Component({})
export default class ProfileForm extends Vue {
  @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

  @Getter('getApplicationId', { namespace: 'profile' }) applicationId!: string;

  valid = null;
  saving = false;
  loading = false;
  isCreate = true;
  profileTitle = '';
  profileAreas: Array<Area> = [];
  allAreas: Array<Area> = [];

  async created() {
    this.isCreate = !this.$route.params.id;
    if (!this.isCreate) {
      this.loading = true;
      await this.getProfile();
    }

    await this.getAreas();
  }

  get areas(): Array<Area> {
    const retVal: Array<Area> = [];

    if (this.allAreas) {
      this.allAreas.forEach((matrix: Area) => {
        const profileArea = this.profileAreas.find(x => x.title == matrix.title);
        if (profileArea) {
          matrix.menus.forEach((menu: Menu) => {
            const profileMenu = profileArea.menus.find(x => x.title == menu.title);
            if (profileMenu) {
              menu.flgInclude = true;
              menu.permissions.forEach((permission: Permission) => {
                const profilePermission = profileMenu.permissions.find(x => x.action == permission.action);

                permission.active = profilePermission ? profilePermission.active : false;
                permission.flgActive = true;
              });
            } else {
              menu.flgInclude = false;
            }
          });
        } else {
          matrix.menus.forEach((menu: Menu) => {
            menu.flgInclude = false;
            if (menu.permissions && menu.permissions.length > 0) {
              menu.permissions.forEach((permission: Permission) => {
                permission.active = false;
                permission.flgActive = false;
              });
            }
          });
        }

        retVal.push(matrix);
      });
    }

    if (retVal.length > 0) {
      this.loading = false;
    }
    return retVal;
  }

  async getProfile(): Promise<void> {
    try {
      const response = await this.$http.get(`${Endpoint.Url.profile.getById}/${this.$route.params.id}`);
      console.log('profile resp', JSON.parse(JSON.stringify(response)));

      this.profileTitle = response.data.title;
      if (response.data && response.data.areas.length > 0) {
        response.data.areas.forEach((area: Area) => {
          if (area.title) {
            this.profileAreas.push(area);
          }
        });
        console.log('this.profileAreas', JSON.parse(JSON.stringify(this.profileAreas)));
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async getAreas(): Promise<void> {
    try {
      const response = await this.$http.get(Endpoint.Url.profile.getAllAreas);
      console.log('allareas', JSON.parse(JSON.stringify(response.data)));

      if (response.data && response.data.length > 0) {
        response.data.forEach((area: Area) => {
          if (area.title) {
            this.allAreas.push(area);
          }
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  async saveAsync(): Promise<void> {
    this.saving = true;
    if (this.isCreate) {
      await this.createAsync();
    } else {
      await this.updateAsync();
    }
  }

  async createAsync(): Promise<void> {
    const profile = {
      title: this.profileTitle,
      areas: this.areas
    };

    try {
      this.saving = true;
      await this.$http.post(`${Endpoint.Url.profile.create}/${this.applicationId}`, profile);
      this.saving = false;

      this.setSnackbar({
        show: true,
        message: `created with Success`,
        color: 'success'
      });

      this.$router.push({ name: 'IndexProfile' });
    } catch (error) {
      console.log('error');
      this.saving = false;

      this.setSnackbar({
        show: true,
        message: 'Error in create profile',
        color: 'error'
      });
    }
  }

  async updateAsync(): Promise<void> {
    const profile = {
      id: this.$route.params.id,
      title: this.profileTitle,
      areas: this.areas
    };

    try {
      this.saving = true;
      await this.$http.put(Endpoint.Url.profile.update, profile);

      this.setSnackbar({
        show: true,
        message: `updated with Success`,
        color: 'success'
      });

      this.$router.push({ name: 'IndexProfile' });
    } catch (error) {
      console.log('error', error);
      this.saving = false;

      this.setSnackbar({
        show: true,
        message: 'Error in update profile',
        color: 'error'
      });
    }
  }

  setMenuState(menu: Menu): void {
    menu.permissions.forEach((permision: Permission) => {
      permision.flgActive = menu.flgInclude;
      permision.active = menu.flgInclude;
    });
    this.$forceUpdate();
  }
}
